<template>
    <div>
        <div class="bg-white border-bottom" style="border-top: 30px solid #06a9d8 !important;">
            <div class="container py-4">
                <div class="d-flex justify-content-between align-items-center flex-wrap">
                    <div>
                        <h3 class="font-weight-bold mb-1">Job Application Form</h3>
                        <small class="text-muted">Hextar — Employment Application</small>
                    </div>
                    <img src="https://getasia.s3.ap-southeast-1.amazonaws.com/images/hextar_logo.png" style="height: 58px; width: auto;">
                </div>
            </div>
        </div>
        <div class="bg-light py-4">
            <div class="container" v-if="status.detail">
                <form v-if="status.detail" @submit.prevent="openDeclaration">
                    <div class="card border mb-3">
                        <div class="card-body px-4 py-4">
                            <h5 class="font-weight-bold mb-3 px-3 py-2" style="background-color: #60d1f2; color: #172b3a;">
                                <i class="mdi mdi-briefcase-outline mr-1"></i>
                                Application Details
                            </h5>
                            <div class="row">
                                <div class="col-md-8">
                                    <b-form-group
                                        label="Job Applied"
                                        label-cols="3"
                                        label-align="left"
                                    >
                                        <multiselect
                                            v-model="createForm.candidate.candidateJob"
                                            track-by="value"
                                            label="text"
                                            :placeholder="'Select'"
                                            :select-label="'Select'"
                                            :selected-label="'Selected'"
                                            :deselect-label="'Select'"
                                            :options="candidateJobDdl"
                                            :searchable="true"
                                            :allow-empty="false"
                                            class="cursor-pointer"
                                            :class="{ 'border border-danger': submitted && !$v.createForm.candidate.candidateJob.required }"
                                            :disabled="!!candidateJobFromQuery"
                                        />
                                        <div v-if="submitted && !$v.createForm.candidate.candidateJob.required" class="invalid-feedback d-block text-right">
                                            {{ $t('message.requiredX', ['Job Applied']) }}
                                        </div>
                                    </b-form-group>
                                </div>
                                <!-- <div class="col-md-4">
                                    <b-form-group
                                        label="Expected Salary"
                                        label-cols="4"
                                        label-align="left"
                                    >
                                        <b-form-input
                                            v-model.trim="createForm.candidate.expectedSalary"
                                            autocomplete="off"
                                        />
                                    </b-form-group>
                                </div> -->
                            </div>
                        </div>
                    </div>
                    <div class="bg-white border rounded mb-3 px-4 py-3">
                        <p class="mb-2">It is important that you read the guidance notes before completing this application form.</p>
                        <div class="font-weight-bold text-center py-2 px-2" style="background-color: #60d1f2; color: #172b3a;">
                            THE INFORMATION YOU SUPPLY ON THIS FORM WILL BE TREATED IN CONFIDENCE.
                        </div>
                    </div>

                    <div class="card border mb-3">
                        <div class="card-body px-4 py-4">
                            <h5 class="font-weight-bold mb-3 px-3 py-2" style="background-color: #60d1f2; color: #172b3a;">
                                <i class="mdi mdi-account-outline mr-1"></i>
                                Section 1 — Personal Details
                            </h5>
                            <div class="row">
                                <div class="col-md-6">
                                    <b-form-group
                                        label="First Name"
                                        label-cols="4"
                                        label-align="left"
                                    >
                                        <b-form-input
                                            v-model.trim="createForm.candidate.firstName"
                                            :class="{ 'is-invalid': submitted && !$v.createForm.candidate.firstName.required }"
                                            autocomplete="off"
                                        />
                                        <b-form-invalid-feedback v-if="submitted && !$v.createForm.candidate.firstName.required" class="text-right">
                                            {{ $t('message.requiredX', ['First Name']) }}
                                        </b-form-invalid-feedback>
                                    </b-form-group>
                                </div>
                                <div class="col-md-6">
                                    <b-form-group
                                        label="Last Name"
                                        label-cols="4"
                                        label-align="left"
                                    >
                                        <b-form-input
                                            v-model.trim="createForm.candidate.lastName"
                                            :class="{ 'is-invalid': submitted && !$v.createForm.candidate.lastName.required }"
                                            autocomplete="off"
                                        />
                                        <b-form-invalid-feedback v-if="submitted && !$v.createForm.candidate.lastName.required" class="text-right">
                                            {{ $t('message.requiredX', ['Last Name']) }}
                                        </b-form-invalid-feedback>
                                    </b-form-group>
                                </div>
                                <div class="col-md-12">
                                    <b-form-group
                                        label="Address"
                                        label-cols="2"
                                        label-align="left"
                                    >
                                        <b-form-input
                                            v-model.trim="createForm.candidate.address1"
                                            autocomplete="off"
                                        />
                                    </b-form-group>
                                </div>
                                <div class="col-md-12">
                                    <b-form-group
                                        label=""
                                        label-cols="2"
                                        label-align="left"
                                    >
                                        <b-form-input
                                            v-model.trim="createForm.candidate.address2"
                                            autocomplete="off"
                                        />
                                    </b-form-group>
                                </div>
                                <div class="col-md-12">
                                    <b-form-group
                                        label=""
                                        label-cols="2"
                                        label-align="left"
                                    >
                                        <b-form-input
                                            v-model.trim="createForm.candidate.address3"
                                            autocomplete="off"
                                        />
                                    </b-form-group>
                                </div>
                                <div class="col-md-6">
                                    <b-form-group
                                        label="City"
                                        label-cols="4"
                                        label-align="left"
                                    >
                                        <b-form-input
                                            v-model.trim="createForm.candidate.city"
                                            autocomplete="off"
                                        />
                                    </b-form-group>
                                </div>
                                <div class="col-md-6">
                                    <b-form-group
                                        label="State"
                                        label-cols="4"
                                        label-align="left"
                                    >
                                        <b-form-input
                                            v-model.trim="createForm.candidate.state"
                                            autocomplete="off"
                                        />
                                    </b-form-group>
                                </div>
                                <div class="col-md-6">
                                    <b-form-group
                                        label="Postcode"
                                        label-cols="4"
                                        label-align="left"
                                    >
                                        <b-form-input
                                            v-model.trim="createForm.candidate.postcode"
                                            autocomplete="off"
                                        />
                                    </b-form-group>
                                </div>
                                <div class="col-md-6">
                                    <b-form-group
                                        label="Country"
                                        label-cols="4"
                                        label-align="left"
                                    >
                                        <b-form-input
                                            v-model.trim="createForm.candidate.country"
                                            autocomplete="off"
                                        />
                                    </b-form-group>
                                </div>
                                <div class="col-md-6">
                                    <b-form-group
                                        label="Phone"
                                        label-cols="4"
                                        label-align="left"
                                    >
                                        <vue-tel-input
                                            v-on:country-changed="(country) => phoneCountryChanged(country)"
                                            v-model.trim="createForm.candidate.phoneNumber"
                                            :defaultCountry="createForm.candidate.phoneIso || 'MY'"
                                            :autoDefaultCountry="false"
                                            :autoFormat="false"
                                            autocomplete="off"
                                        />
                                    </b-form-group>
                                </div>
                                <div class="col-md-6">
                                    <b-form-group
                                        label="Home Phone"
                                        label-cols="4"
                                        label-align="left"
                                    >
                                        <vue-tel-input
                                            v-on:country-changed="(country) => homePhoneCountryChanged(country)"
                                            v-model.trim="createForm.candidate.homePhoneNumber"
                                            :defaultCountry="createForm.candidate.homePhoneIso || 'MY'"
                                            :autoDefaultCountry="false"
                                            :autoFormat="false"
                                            autocomplete="off"
                                        />
                                    </b-form-group>
                                </div>
                                <div class="col-md-6">
                                    <b-form-group
                                        label="Email"
                                        label-cols="4"
                                        label-align="left"
                                    >
                                        <b-form-input
                                            v-model.trim="createForm.candidate.email"
                                            :class="{ 'is-invalid': submitted && $v.createForm.candidate.email.$error }"
                                            autocomplete="off"
                                        />
                                        <b-form-invalid-feedback v-if="submitted && $v.createForm.candidate.email.$error" class="text-right">
                                            <span v-if="!$v.createForm.candidate.email.required">{{ $t('message.requiredX', ['Email']) }}</span>
                                            <span v-else-if="!$v.createForm.candidate.email.email">{{ $t('message.invalidX', ['Email']) }}</span>
                                        </b-form-invalid-feedback>
                                    </b-form-group>
                                </div>
                                <div class="col-md-6"></div>
                                <div class="col-md-6">
                                    <b-form-group
                                        label="Birth Date"
                                        label-cols="4"
                                        label-align="left"
                                    >
                                        <DatePicker
                                            v-model="createForm.candidate.birthDate"
                                            placeholder="yyyy-mm-dd"
                                            class="cursor-pointer"
                                            :config="{
                                                format: 'YYYY-MM-DD',
                                                useCurrent: false,
                                                icons: {
                                                    time: 'mdi mdi-clock-outline',
                                                    date: 'mdi mdi-calendar',
                                                    up: 'mdi mdi-chevron-up',
                                                    down: 'mdi mdi-chevron-down',
                                                    previous: 'mdi mdi-chevron-left',
                                                    next: 'mdi mdi-chevron-right',
                                                    today: 'mdi mdi-calendar-check',
                                                    clear: 'mdi mdi-delete-outline',
                                                    close: 'mdi mdi-close',
                                                },
                                            }"
                                        />
                                    </b-form-group>
                                </div>
                                <div class="col-md-6">
                                    <b-form-group
                                        label="Birth Place"
                                        label-cols="4"
                                        label-align="left"
                                    >
                                        <b-form-input
                                            v-model.trim="createForm.candidate.birthPlace"
                                            autocomplete="off"
                                        />
                                    </b-form-group>
                                </div>
                                <div class="col-md-6">
                                    <b-form-group
                                        label="Gender"
                                        label-cols="4"
                                        label-align="left"
                                    >
                                        <b-form-select
                                            v-model="createForm.candidate.gender"
                                            :options="[{ value: 1, text: 'Male' }, { value: 0, text: 'Female' }]"
                                        />
                                    </b-form-group>
                                </div>
                                <div class="col-md-6"></div>
                                <div class="col-md-6">
                                    <b-form-group
                                        label="Race"
                                        label-cols="4"
                                        label-align="left"
                                    >
                                        <b-form-input
                                            v-model.trim="createForm.candidate.race"
                                            autocomplete="off"
                                        />
                                    </b-form-group>
                                </div>
                                <div class="col-md-6">
                                    <b-form-group
                                        label="Ethnicity"
                                        label-cols="4"
                                        label-align="left"
                                    >
                                        <b-form-input
                                            v-model.trim="createForm.candidate.ethnicity"
                                            autocomplete="off"
                                        />
                                    </b-form-group>
                                </div>
                                <div class="col-md-6">
                                    <b-form-group
                                        label="Religion"
                                        label-cols="4"
                                        label-align="left"
                                    >
                                        <b-form-input
                                            v-model.trim="createForm.candidate.religion"
                                            autocomplete="off"
                                        />
                                    </b-form-group>
                                </div>
                                <div class="col-md-6">
                                    <b-form-group
                                        label="Nationality"
                                        label-cols="4"
                                        label-align="left"
                                    >
                                        <b-form-input
                                            v-model.trim="createForm.candidate.nationality"
                                            autocomplete="off"
                                        />
                                    </b-form-group>
                                </div>
                                <div class="col-md-6">
                                    <b-form-group
                                        label="Marital Status"
                                        label-cols="4"
                                        label-align="left"
                                    >
                                        <b-form-select
                                            v-model="createForm.candidate.maritalStatus"
                                            :options="maritalStatusDdl"
                                        />
                                    </b-form-group>
                                </div>
                                <div class="col-md-6"></div>
                                <div class="col-md-6">
                                    <b-form-group
                                        label="Malaysia ID"
                                        label-cols="4"
                                        label-align="left"
                                    >
                                        <b-form-input
                                            v-model.trim="createForm.candidate.malaysiaId"
                                            autocomplete="off"
                                        />
                                    </b-form-group>
                                </div>
                                <div class="col-md-6"></div>
                                <div class="col-md-6">
                                    <b-form-group
                                        label="Passport"
                                        label-cols="4"
                                        label-align="left"
                                    >
                                        <b-form-input
                                            v-model.trim="createForm.candidate.passportNumber"
                                            autocomplete="off"
                                        />
                                    </b-form-group>
                                </div>
                                <div class="col-md-6">
                                    <b-form-group
                                        label="Passport Expired"
                                        label-cols="4"
                                        label-align="left"
                                    >
                                        <DatePicker
                                            v-model="createForm.candidate.passportExpiredDate"
                                            placeholder="yyyy-mm-dd"
                                            class="cursor-pointer"
                                            :config="{
                                                format: 'YYYY-MM-DD',
                                                useCurrent: false,
                                                icons: {
                                                    time: 'mdi mdi-clock-outline',
                                                    date: 'mdi mdi-calendar',
                                                    up: 'mdi mdi-chevron-up',
                                                    down: 'mdi mdi-chevron-down',
                                                    previous: 'mdi mdi-chevron-left',
                                                    next: 'mdi mdi-chevron-right',
                                                    today: 'mdi mdi-calendar-check',
                                                    clear: 'mdi mdi-delete-outline',
                                                    close: 'mdi mdi-close',
                                                },
                                            }"
                                        />
                                    </b-form-group>
                                </div>
                                <div class="col-md-4">
                                    <b-form-group
                                        label="If need, are you willing to work overtime?"
                                        label-cols="12"
                                        label-align="left"
                                    >
                                        <b-form-checkbox
                                            v-model="createForm.candidate.willingOt"
                                            switch
                                        />
                                    </b-form-group>
                                </div>
                                <div class="col-md-4">
                                    <b-form-group
                                        label="Can we contact you at work?"
                                        label-cols="12"
                                        label-align="left"
                                    >
                                        <b-form-checkbox
                                            v-model="createForm.candidate.callDuringWork"
                                            switch
                                        />
                                    </b-form-group>
                                </div>
                                <div class="col-md-4">
                                    <b-form-group
                                        label="Are you willing to relocate?"
                                        label-cols="12"
                                        label-align="left"
                                    >
                                        <b-form-checkbox
                                            v-model="createForm.candidate.willingToRelocate"
                                            switch
                                        />
                                    </b-form-group>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card border mb-3">
                        <div class="card-body px-4 py-4">
                            <div class="d-flex justify-content-between align-items-center mb-3 px-3 py-2" style="background-color: #60d1f2;">
                                <h5 class="font-weight-bold mb-0" style="color: #172b3a;">
                                    <i class="mdi mdi-briefcase-outline mr-1"></i>
                                    Section 2 — Employment History
                                </h5>
                            </div>
                            <div
                                v-for="(item, index) in createForm.experiences"
                                :key="index"
                                class="border rounded p-3 mb-3 bg-white"
                            >
                                <div class="d-flex justify-content-between align-items-center mb-3">
                                    <h6 class="font-weight-bold mb-0">Employment {{ index + 1 }}</h6>
                                    <b-button
                                        variant="outline-danger"
                                        size="sm"
                                        @click="createForm.experiences.splice(index, 1)"
                                    >
                                        <i class="mdi mdi-close"></i>
                                    </b-button>
                                </div>
                                <div class="row">
                                    <div class="col-md-6">
                                        <b-form-group label="Name of Employer">
                                            <b-form-input
                                                v-model.trim="item.company"
                                                autocomplete="off"
                                            />
                                        </b-form-group>
                                    </div>
                                    <div class="col-md-6">
                                        <b-form-group label="Position Held">
                                            <b-form-input
                                                v-model.trim="item.name"
                                                autocomplete="off"
                                            />
                                        </b-form-group>
                                    </div>
                                    <div class="col-md-12">
                                        <b-form-group label="Address">
                                            <b-form-textarea
                                                v-model.trim="item.address"
                                                autocomplete="off"
                                            />
                                        </b-form-group>
                                    </div>
                                    <div class="col-md-4">
                                        <b-form-group label="Department">
                                            <b-form-input
                                                v-model.trim="item.department"
                                                autocomplete="off"
                                            />
                                        </b-form-group>
                                    </div>
                                    <div class="col-md-4">
                                        <b-form-group label="Location">
                                            <b-form-input
                                                v-model.trim="item.location"
                                                autocomplete="off"
                                            />
                                        </b-form-group>
                                    </div>
                                    <div class="col-md-4">
                                        <b-form-group label="Salary">
                                            <b-form-input
                                                v-model.trim="item.salary"
                                                autocomplete="off"
                                            />
                                        </b-form-group>
                                    </div>
                                    <div class="col-md-4">
                                        <b-form-group label="Start Date">
                                            <DatePicker
                                                v-model="item.startDate"
                                                placeholder="yyyy-mm-dd"
                                                class="cursor-pointer"
                                                :config="{
                                                    format: 'YYYY-MM-DD',
                                                    useCurrent: false,
                                                    icons: {
                                                        time: 'mdi mdi-clock-outline',
                                                        date: 'mdi mdi-calendar',
                                                        up: 'mdi mdi-chevron-up',
                                                        down: 'mdi mdi-chevron-down',
                                                        previous: 'mdi mdi-chevron-left',
                                                        next: 'mdi mdi-chevron-right',
                                                        today: 'mdi mdi-calendar-check',
                                                        clear: 'mdi mdi-delete-outline',
                                                        close: 'mdi mdi-close',
                                                    },
                                                }"
                                            />
                                        </b-form-group>
                                    </div>
                                    <div class="col-md-4">
                                        <b-form-group label="End Date">
                                            <DatePicker
                                                v-model="item.endDate"
                                                placeholder="yyyy-mm-dd"
                                                class="cursor-pointer"
                                                :config="{
                                                    format: 'YYYY-MM-DD',
                                                    useCurrent: false,
                                                    icons: {
                                                        time: 'mdi mdi-clock-outline',
                                                        date: 'mdi mdi-calendar',
                                                        up: 'mdi mdi-chevron-up',
                                                        down: 'mdi mdi-chevron-down',
                                                        previous: 'mdi mdi-chevron-left',
                                                        next: 'mdi mdi-chevron-right',
                                                        today: 'mdi mdi-calendar-check',
                                                        clear: 'mdi mdi-delete-outline',
                                                        close: 'mdi mdi-close',
                                                    },
                                                }"
                                            />
                                        </b-form-group>
                                    </div>
                                    <div class="col-md-4">
                                        <b-form-group label="Current">
                                            <b-form-checkbox
                                                v-model="item.isCurrent"
                                                switch
                                                class="mt-2"
                                            />
                                        </b-form-group>
                                    </div>
                                    <div class="col-md-6">
                                        <b-form-group label="Years of Service">
                                            <b-form-input
                                                v-model.trim="item.yearsOfService"
                                                autocomplete="off"
                                            />
                                        </b-form-group>
                                    </div>
                                    <div class="col-md-6">
                                        <b-form-group label="Notice Month">
                                            <b-form-input
                                                v-model.trim="item.periodNoticeMonth"
                                                autocomplete="off"
                                            />
                                        </b-form-group>
                                    </div>
                                    <div class="col-md-6">
                                        <b-form-group label="Reason For Leaving">
                                            <b-form-textarea
                                                v-model.trim="item.reasonForLeaving"
                                            />
                                        </b-form-group>
                                    </div>
                                    <div class="col-md-6">
                                        <b-form-group label="Service Summary">
                                            <b-form-textarea
                                                v-model.trim="item.serviceSummary"
                                            />
                                        </b-form-group>
                                    </div>
                                </div>
                            </div>
                            <div class="d-flex justify-content-end">
                                <b-button
                                    variant="info"
                                    size="sm"
                                    @click="createForm.experiences.push(defaultExperience())"
                                >
                                    <i class="mdi mdi-plus"></i>
                                </b-button>
                            </div>
                        </div>
                    </div>

                    <div class="card border mb-3">
                        <div class="card-body px-4 py-4">
                            <div class="d-flex justify-content-between align-items-center mb-3 px-3 py-2" style="background-color: #60d1f2;">
                                <h5 class="font-weight-bold mb-0" style="color: #172b3a;">
                                    <i class="mdi mdi-school-outline mr-1"></i>
                                    Section 3 — Education
                                </h5>
                            </div>
                            <div
                                v-for="(item, index) in createForm.educations"
                                :key="index"
                                class="border rounded p-3 mb-3 bg-white"
                            >
                                <div class="d-flex justify-content-between align-items-center mb-3">
                                    <h6 class="font-weight-bold mb-0">Education {{ index + 1 }}</h6>
                                    <b-button
                                        variant="outline-danger"
                                        size="sm"
                                        @click="createForm.educations.splice(index, 1)"
                                    >
                                        <i class="mdi mdi-close"></i>
                                    </b-button>
                                </div>
                                <div class="row">
                                    <div class="col-md-4">
                                        <b-form-group label="Qualification">
                                            <b-form-input
                                                v-model.trim="item.name"
                                                placeholder="e.g. SPM, Diploma, Bachelor's Degree"
                                                autocomplete="off"
                                            />
                                        </b-form-group>
                                    </div>
                                    <div class="col-md-4">
                                        <b-form-group label="Field">
                                            <b-form-input
                                                v-model.trim="item.field"
                                                placeholder="e.g. Accounting, Engineering, Science"
                                                autocomplete="off"
                                            />
                                        </b-form-group>
                                    </div>
                                    <div class="col-md-2">
                                        <b-form-group label="Start Date">
                                            <DatePicker
                                                v-model="item.startDate"
                                                placeholder="yyyy-mm-dd"
                                                class="cursor-pointer"
                                                :config="{
                                                    format: 'YYYY-MM-DD',
                                                    useCurrent: false,
                                                    icons: {
                                                        time: 'mdi mdi-clock-outline',
                                                        date: 'mdi mdi-calendar',
                                                        up: 'mdi mdi-chevron-up',
                                                        down: 'mdi mdi-chevron-down',
                                                        previous: 'mdi mdi-chevron-left',
                                                        next: 'mdi mdi-chevron-right',
                                                        today: 'mdi mdi-calendar-check',
                                                        clear: 'mdi mdi-delete-outline',
                                                        close: 'mdi mdi-close',
                                                    },
                                                }"
                                            />
                                        </b-form-group>
                                    </div>
                                    <div class="col-md-2">
                                        <b-form-group label="End Date">
                                            <DatePicker
                                                v-model="item.endDate"
                                                placeholder="yyyy-mm-dd"
                                                class="cursor-pointer"
                                                :config="{
                                                    format: 'YYYY-MM-DD',
                                                    useCurrent: false,
                                                    icons: {
                                                        time: 'mdi mdi-clock-outline',
                                                        date: 'mdi mdi-calendar',
                                                        up: 'mdi mdi-chevron-up',
                                                        down: 'mdi mdi-chevron-down',
                                                        previous: 'mdi mdi-chevron-left',
                                                        next: 'mdi mdi-chevron-right',
                                                        today: 'mdi mdi-calendar-check',
                                                        clear: 'mdi mdi-delete-outline',
                                                        close: 'mdi mdi-close',
                                                    },
                                                }"
                                            />
                                        </b-form-group>
                                    </div>
                                    <div class="col-md-4">
                                        <b-form-group label="School / College / University">
                                            <b-form-input
                                                v-model.trim="item.institute"
                                                autocomplete="off"
                                            />
                                        </b-form-group>
                                    </div>
                                    <div class="col-md-4">
                                        <b-form-group label="Location">
                                            <b-form-input
                                                v-model.trim="item.location"
                                                autocomplete="off"
                                            />
                                        </b-form-group>
                                    </div>
                                    <div class="col-md-4">
                                        <b-form-group label="Grade">
                                            <b-form-input
                                                v-model.trim="item.grade"
                                                placeholder="e.g. 5A3B, CGPA 3.50"
                                                autocomplete="off"
                                            />
                                        </b-form-group>
                                    </div>
                                    <div class="col-md-12">
                                        <b-form-group label="Description">
                                            <b-form-textarea
                                                v-model.trim="item.description"
                                            />
                                        </b-form-group>
                                    </div>
                                </div>
                            </div>
                            <div class="d-flex justify-content-end">
                                <b-button
                                    variant="info"
                                    size="sm"
                                    @click="createForm.educations.push(defaultEducation())"
                                >
                                    <i class="mdi mdi-plus"></i>
                                </b-button>
                            </div>
                        </div>
                    </div>

                    <div class="card border mb-3">
                        <div class="card-body px-4 py-4">
                            <div class="d-flex justify-content-between align-items-center mb-3 px-3 py-2" style="background-color: #60d1f2;">
                                <h5 class="font-weight-bold mb-0" style="color: #172b3a;">
                                    <i class="mdi mdi-account-group-outline mr-1"></i>
                                    Section 4 — Family Background
                                </h5>
                            </div>
                            <div
                                v-for="(item, index) in createForm.families"
                                :key="index"
                                class="border rounded p-3 mb-3 bg-white"
                            >
                                <div class="d-flex justify-content-between align-items-center mb-3">
                                    <h6 class="font-weight-bold mb-0">Family {{ index + 1 }}</h6>
                                    <b-button
                                        variant="outline-danger"
                                        size="sm"
                                        @click="createForm.families.splice(index, 1)"
                                    >
                                        <i class="mdi mdi-close"></i>
                                    </b-button>
                                </div>
                                <div class="row">
                                    <div class="col-md-4">
                                        <b-form-group label="Name">
                                            <b-form-input
                                                v-model.trim="item.name"
                                                autocomplete="off"
                                            />
                                        </b-form-group>
                                    </div>
                                    <div class="col-md-4">
                                        <b-form-group label="Relationship">
                                            <b-form-input
                                                v-model.trim="item.relationship"
                                                autocomplete="off"
                                            />
                                        </b-form-group>
                                    </div>
                                    <div class="col-md-4">
                                        <b-form-group label="Occupation">
                                            <b-form-input
                                                v-model.trim="item.occupation"
                                                autocomplete="off"
                                            />
                                        </b-form-group>
                                    </div>
                                    <div class="col-md-12">
                                        <b-form-group label="Address">
                                            <b-form-textarea
                                                v-model.trim="item.address"
                                                autocomplete="off"
                                            />
                                        </b-form-group>
                                    </div>
                                    <div class="col-md-8">
                                        <b-form-group label="Phone">
                                            <vue-tel-input
                                                v-on:country-changed="(country) => familyPhoneCountryChanged(country, item)"
                                                v-model.trim="item.phoneNumber"
                                                :defaultCountry="item.phoneIso || 'MY'"
                                                :autoDefaultCountry="false"
                                                :autoFormat="false"
                                                autocomplete="off"
                                            />
                                        </b-form-group>
                                    </div>
                                    <div class="col-md-4">
                                        <b-form-group label="Emergency Contact">
                                            <b-form-checkbox
                                                v-model="item.isEmergency"
                                                switch
                                                class="mt-2"
                                            />
                                        </b-form-group>
                                    </div>
                                </div>
                            </div>
                            <div class="d-flex justify-content-end">
                                <b-button
                                    variant="info"
                                    size="sm"
                                    @click="createForm.families.push(defaultFamily())"
                                >
                                    <i class="mdi mdi-plus"></i>
                                </b-button>
                            </div>
                        </div>
                    </div>
                    <div class="card border mb-3">
                        <div class="card-body px-4 py-4">
                            <div class="d-flex justify-content-between align-items-center mb-3 px-3 py-2" style="background-color: #60d1f2;">
                                <h5 class="font-weight-bold mb-0" style="color: #172b3a;">
                                    <i class="mdi mdi-translate mr-1"></i>
                                    Section 5 — Languages
                                </h5>
                            </div>
                            <div
                                v-for="(item, index) in createForm.languages"
                                :key="index"
                                class="border rounded p-3 mb-3 bg-white"
                            >
                                <div class="d-flex justify-content-between align-items-center mb-3">
                                    <h6 class="font-weight-bold mb-0">Language {{ index + 1 }}</h6>
                                    <b-button
                                        variant="outline-danger"
                                        size="sm"
                                        @click="createForm.languages.splice(index, 1)"
                                    >
                                        <i class="mdi mdi-close"></i>
                                    </b-button>
                                </div>
                                <div class="row">
                                    <div class="col-md-4">
                                        <b-form-group label="Language">
                                            <b-form-input
                                                v-model.trim="item.name"
                                                autocomplete="off"
                                            />
                                        </b-form-group>
                                    </div>
                                    <div class="col-md-2">
                                        <b-form-group label="Write">
                                            <div class="d-flex align-items-center">
                                                <b-form-input
                                                    v-model.trim="item.write"
                                                    type="range"
                                                    min="1"
                                                    max="5"
                                                    autocomplete="off"
                                                />
                                                <span class="ml-2">{{ item.write }}</span>
                                            </div>
                                        </b-form-group>
                                    </div>
                                    <div class="col-md-2">
                                        <b-form-group label="Read">
                                            <div class="d-flex align-items-center">
                                                <b-form-input
                                                    v-model.trim="item.read"
                                                    type="range"
                                                    min="1"
                                                    max="5"
                                                    autocomplete="off"
                                                />
                                                <span class="ml-2">{{ item.read }}</span>
                                            </div>
                                        </b-form-group>
                                    </div>
                                    <div class="col-md-2">
                                        <b-form-group label="Spoken">
                                            <div class="d-flex align-items-center">
                                                <b-form-input
                                                    v-model.trim="item.spoken"
                                                    type="range"
                                                    min="1"
                                                    max="5"
                                                    autocomplete="off"
                                                />
                                                <span class="ml-2">{{ item.spoken }}</span>
                                            </div>
                                        </b-form-group>
                                    </div>
                                    <div class="col-md-2">
                                        <b-form-group label="Listen">
                                            <div class="d-flex align-items-center">
                                                <b-form-input
                                                    v-model.trim="item.listen"
                                                    type="range"
                                                    min="1"
                                                    max="5"
                                                    autocomplete="off"
                                                />
                                                <span class="ml-2">{{ item.listen }}</span>
                                            </div>
                                        </b-form-group>
                                    </div>
                                </div>
                            </div>
                            <div class="d-flex justify-content-end">
                                <b-button
                                    variant="info"
                                    size="sm"
                                    @click="createForm.languages.push(defaultLanguage())"
                                >
                                    <i class="mdi mdi-plus"></i>
                                </b-button>
                            </div>
                        </div>
                    </div>
                    <div class="card border mb-3">
                        <div class="card-body px-4 py-4">
                            <h5 class="font-weight-bold mb-3 px-3 py-2" style="background-color: #60d1f2; color: #172b3a;">
                                <i class="mdi mdi-medical-bag mr-1"></i>
                                Section 6 — Health
                            </h5>
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="row align-items-center mb-2">
                                        <div class="col-md-4">
                                            Blood Type
                                        </div>
                                        <div class="col-md-8">
                                            <b-form-input
                                                v-model.trim="createForm.medical.bloodType"
                                                autocomplete="off"
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-12">
                                    <div class="row align-items-center mb-2">
                                        <div class="col-md-4">
                                            <b-form-checkbox
                                                v-model="createForm.medical.physicalImpairmentDisease"
                                                @change="createForm.medical.physicalImpairmentDiseaseRemark = $event ? createForm.medical.physicalImpairmentDiseaseRemark : ''"
                                                switch
                                            >
                                                Physical Impairment / Disease
                                            </b-form-checkbox>
                                        </div>
                                        <div class="col-md-8">
                                            <b-form-input
                                                v-model.trim="createForm.medical.physicalImpairmentDiseaseRemark"
                                                placeholder="Remark"
                                                autocomplete="off"
                                                :class="[createForm.medical.physicalImpairmentDisease ? 'fade-in' : 'bg-light']"
                                                :disabled="!createForm.medical.physicalImpairmentDisease"
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-12">
                                    <div class="row align-items-center mb-2">
                                        <div class="col-md-4">
                                            <b-form-checkbox
                                                v-model="createForm.medical.seriousIllness"
                                                @change="createForm.medical.seriousIllnessRemark = $event ? createForm.medical.seriousIllnessRemark : ''"
                                                switch
                                            >
                                                Serious Illness
                                            </b-form-checkbox>
                                        </div>
                                        <div class="col-md-8">
                                            <b-form-input
                                                v-model.trim="createForm.medical.seriousIllnessRemark"
                                                placeholder="Remark"
                                                autocomplete="off"
                                                :class="[createForm.medical.seriousIllness ? 'fade-in' : 'bg-light']"
                                                :disabled="!createForm.medical.seriousIllness"
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-12">
                                    <div class="row align-items-center mb-2">
                                        <div class="col-md-4">
                                            <b-form-checkbox
                                                v-model="createForm.medical.medicationAllergy"
                                                @change="createForm.medical.medicationAllergyRemark = $event ? createForm.medical.medicationAllergyRemark : ''"
                                                switch
                                            >
                                                Medication Allergy
                                            </b-form-checkbox>
                                        </div>
                                        <div class="col-md-8">
                                            <b-form-input
                                                v-model.trim="createForm.medical.medicationAllergyRemark"
                                                placeholder="Remark"
                                                autocomplete="off"
                                                :class="[createForm.medical.medicationAllergy ? 'fade-in' : 'bg-light']"
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-12">
                                    <div class="row align-items-center">
                                        <div class="col-md-4">
                                            <b-form-checkbox
                                                v-model="createForm.medical.isPregnant"
                                                switch
                                            >
                                                Pregnant
                                            </b-form-checkbox>
                                        </div>
                                        <div class="col-md-8">
                                            <b-form-input
                                                v-model.trim="createForm.medical.pregnantMonth"
                                                placeholder="Month"
                                                autocomplete="off"
                                                :class="[createForm.medical.isPregnant ? 'fade-in': 'bg-light']"
                                                :disabled="!createForm.medical.isPregnant"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="card border mb-3">
                        <div class="card-body px-4 py-4">
                            <h5 class="font-weight-bold mb-3 px-3 py-2" style="background-color: #60d1f2; color: #172b3a;">
                                <i class="mdi mdi-file-document-outline mr-1"></i>
                                Section 7 — Supporting Documents & Work Preferences
                            </h5>
                            <div class="row">
                                <div class="col-md-6">
                                    <b-form-group
                                        label="Photo"
                                        label-cols="4"
                                        label-align="left"
                                    >
                                        <b-form-file v-model="createForm.candidate.photo" />
                                    </b-form-group>
                                </div>
                                <div class="col-md-6">
                                    <b-form-group
                                        label="Resume"
                                        label-cols="4"
                                        label-align="left"
                                    >
                                        <b-form-file v-model="createForm.candidate.resume" />
                                    </b-form-group>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="d-flex flex-wrap justify-content-end mb-4">
                        <b-button
                            v-if="status.save && this.$route.query.candidate"
                            type="button"
                            variant="outline-info"
                            class="px-4 mr-2 mb-2 col-md-3"
                            @click="candidateUUIDValue ? requestUpdate(false) : requestCreate(false)"
                        >
                            <i class="mdi mdi-content-save-outline mr-1"></i>
                            Save as Draft
                        </b-button>
                        <b-button
                            v-if="status.save"
                            type="submit"
                            variant="info"
                            class="px-4 mb-2 col-md-3"
                        >
                            <span v-if="status.save">
                                <i class="mdi mdi-send mr-1"></i>
                                Submit Application
                            </span>
                        </b-button>
                        <div class="px-5 mx-5" v-if="!status.save">
                            <b-spinner class="mt-2" small />
                        </div>
                    </div>
                </form>
            </div>
            <div v-else class="d-flex justify-content-center align-items-center p-5 m-5">
                <b-spinner class="m-5" variant="info" role="status"></b-spinner>
            </div>
        </div>
        <b-modal
            id="candidate-declaration"
            @hidden="createForm.candidate.signatureImage = null"
            title="Section 8 — Declaration"
            hide-footer
            centered
            size="lg"
            :no-close-on-backdrop="!status.save"
            :no-close-on-esc="!status.save"
            :hide-header-close="!status.save"
        >
            <div class="p-2">
                <div class="border rounded p-4 mb-4" style="background-color: #f2fbfe;">
                    <h5 class="font-weight-bold mb-3">
                        <i class="mdi mdi-file-document-check-outline text-info mr-2"></i>
                        I hereby certify that:
                    </h5>
                    <ul class="pl-4 mb-0">
                        <li class="font-weight-bold mb-3">All the information given by me on this form is correct to the best of my knowledge</li>
                        <li class="font-weight-bold mb-3">All questions relating to me have been accurately and fully answered?</li>
                        <li class="font-weight-bold mb-3">I possess all the qualifications which I claim to hold</li>
                        <li class="font-weight-bold">I have read and, if appointed, am prepared to accept the conditions set out in the conditions of employment and the job description.</li>
                    </ul>
                </div>
                <div class="row">
                    <div class="col-12 col-md-6">
                        <b-form-group label="Signed:">
                            <div
                                class="rounded p-2 bg-white border"
                                :class="{ 'border-danger': submitted && !$v.createForm.candidate.signatureImage.required }"
                            >
                                <CustomESignature @input="updateSignatureImage" />
                                <div v-if="submitted && !$v.createForm.candidate.signatureImage.required" class="text-danger d-flex justify-content-end small mt-2">
                                    {{ $t('message.requiredX', ['Signature']) }}
                                </div>
                            </div>
                        </b-form-group>
                    </div>
                </div>
                <div class="row mt-4">
                    <div class="col-12 col-md-6">
                        <p class="font-weight-bold">Date: {{ declarationDate }}</p>
                    </div>
                </div>
                <hr class="my-4">
                <div class="d-flex justify-content-end">
                    <b-button
                        variant="outline-secondary"
                        class="mr-2 col-md-2"
                        :disabled="!status.save"
                        @click="$bvModal.hide('candidate-declaration')"
                    >
                        Cancel
                    </b-button>
                    <b-button
                        variant="info"
                        class="col-md-3"
                        :disabled="!status.save"
                        @click="candidateUUIDValue ? requestUpdate(true) : requestCreate(true)"
                    >
                        <span v-if="status.save"><i class="mdi mdi-send mr-1"></i>Submit</span>
                        <b-spinner v-else small />
                    </b-button>
                </div>
            </div>
        </b-modal>
    </div>
</template>
<script>
import i18n from "@/i18n";
import { MARITAL_STATUS } from "@/constants/marital";
import CustomESignature from "@/components/custom-e-signature.vue";
import DatePicker from 'vue-bootstrap-datetimepicker';
import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css';
import Multiselect from "vue-multiselect";
import { VueTelInput } from 'vue-tel-input';
import { required, requiredIf, email } from "vuelidate/lib/validators";
import { mapState } from "vuex";
import { candidateMethods, lookupMethods } from "@/state/public";
import { CANDIDATE_MODULE } from "@/state/public/candidate.state";

export default {
    page: {
        title: i18n.t("label.application"),
    },
    components: { DatePicker, Multiselect, VueTelInput, CustomESignature },
    props: {
        candidateUUID: {
            type: String,
            required: false,
        },
    },
    validations() {
        return {
            createForm: {
                candidate: {
                    candidateJob: { required },
                    firstName: { required },
                    lastName: { required },
                    email: { required, email },
                    signatureImage: {
                        required: requiredIf(function () { return this.createForm.candidate.isApplicationCompleted; }),
                    },
                },
            },
        };
    },
    async created() {
        await this.lookupCandidateJob();
        await this.getCandidateData();
    },
    watch: {
        candidateJobFromQuery: {
            immediate: true,
            handler(job) {
                if (job) this.createForm.candidate.candidateJob = job;
            },
        },
    },
    data() {
        return {
            submitted: false,
            declarationDate: "",
            maritalStatusDdl: MARITAL_STATUS,
            createForm: this.defaultForm(),
        };
    },
    methods: {
        ...candidateMethods,
        ...lookupMethods,
        defaultForm() {
            return {
                uuid: null,
                candidate: {
                    candidateJob: null,
                    candidateJobUuid: null,
                    firstName: "",
                    lastName: "",
                    englishName: "",
                    phoneCode: "",
                    phoneIso: "",
                    phoneNumber: "",
                    homePhoneIso: "",
                    homePhoneCode: "",
                    homePhoneNumber: "",
                    email: "",
                    companyEmail: "",
                    birthDate: "",
                    birthPlace: "",
                    gender: null,
                    malaysiaId: "",
                    passportNumber: "",
                    passportExpiredDate: "",
                    maritalStatus: null,
                    nationality: "",
                    race: "",
                    ethnicity: "",
                    religion: "",
                    expectedSalary: "",
                    address1: "",
                    address2: "",
                    address3: "",
                    city: "",
                    state: "",
                    postcode: "",
                    country: "",
                    callDuringWork: false,
                    willingOt: false,
                    willingToRelocate: false,
                    isApplicationCompleted: false,
                    signatureImage: null,
                    photo: null,
                    resume: null,
                },
                languages: [this.defaultLanguage()],
                educations: [this.defaultEducation()],
                experiences: [this.defaultExperience()],
                families: [this.defaultFamily()],
                medical: this.defaultMedical(),
            };
        },
        defaultLanguage() {
            return {
                name: "",
                write: 1,
                read: 1,
                spoken: 1,
                listen: 1,
            };
        },
        defaultEducation() {
            return {
                name: "",
                field: "",
                institute: "",
                location: "",
                grade: "",
                startDate: "",
                endDate: "",
                description: "",
            };
        },
        defaultExperience() {
            return {
                name: "",
                company: "",
                location: "",
                startDate: "",
                endDate: "",
                department: "",
                salary: "",
                periodNoticeMonth: "",
                reasonForLeaving: "",
                isCurrent: false,
                serviceSummary: "",
                address: "",
                yearsOfService: "",
            };
        },
        defaultFamily() {
            return {
                name: "",
                relationship: "",
                occupation: "",
                address: "",
                phoneNumber: "",
                phoneCode: "",
                phoneIso: "",
                isEmergency: false,
            };
        },
        defaultMedical() {
            return {
                physicalImpairmentDisease: false,
                physicalImpairmentDiseaseRemark: "",
                seriousIllness: false,
                seriousIllnessRemark: "",
                medicationAllergy: false,
                medicationAllergyRemark: "",
                bloodType: "",
                isPregnant: false,
                pregnantMonth: "",
            };
        },
        phoneCountryChanged(country) {
            this.createForm.candidate.phoneCode = "+" + country.dialCode;
            this.createForm.candidate.phoneIso = country.iso2;
        },
        homePhoneCountryChanged(country) {
            this.createForm.candidate.homePhoneCode = "+" + country.dialCode;
            this.createForm.candidate.homePhoneIso = country.iso2;
        },
        familyPhoneCountryChanged(country, item) {
            item.phoneCode = "+" + country.dialCode;
            item.phoneIso = country.iso2;
        },
        async getCandidateData() {
            if (this.candidateUUIDValue) {
                await this.getCandidate({ uuid: this.candidateUUIDValue })
                    .then((result) => {
                        if (!result?.success && this.$route.query.candidate) {
                            window.location.href = this.$router.resolve({name: 'CandidateApplicationError'}).href;
                            return;
                        }
                        if (result?.success) {
                            const data = JSON.parse(JSON.stringify(this.data));
                            if (data.isApplicationCompleted) {
                                window.location.href = this.$router.resolve({name: 'CandidateApplicationComplete'}).href;
                                return;
                            }
                            this.createForm = {
                                uuid: data.uuid,
                                candidate: {
                                    ...data,
                                    phoneNumber: String(data.phoneNumber ?? ""),
                                    homePhoneNumber: String(data.homePhoneNumber ?? ""),
                                    candidateJob: this.candidateJobFromQuery || (data.candidateJob ? {
                                        value: data.candidateJob.uuid,
                                        text: data.candidateJob.name,
                                    } : null),
                                    candidateJobUuid: data.candidateJob?.uuid,
                                    signatureImage: null,
                                    photo: null,
                                    resume: null,
                                },
                                languages: data.candidateLanguages.length ? [...data.candidateLanguages] : [this.defaultLanguage()],
                                educations: data.candidateEducations.length ? [...data.candidateEducations] : [this.defaultEducation()],
                                experiences: data.candidateExperiences.length ? [...data.candidateExperiences] : [this.defaultExperience()],
                                families: data.candidateFamilies.length ? data.candidateFamilies.map(item => ({
                                    ...item,
                                    phoneNumber: String(item.phoneNumber ?? ""),
                                })) : [this.defaultFamily()],
                                medical: data.candidateMedical || this.defaultMedical(),
                            };
                        }
                    });
            }
        },
        openDeclaration() {
            this.declarationDate = new Date().toLocaleDateString('en-GB').replace(/\//g, '-');
            this.createForm.candidate.isApplicationCompleted = false;
            this.submitted = true;
            this.$v.$touch();
            if (this.$v.$invalid) {
                return;
            }
            this.submitted = false;
            this.$v.$reset();
            this.$bvModal.show('candidate-declaration');
        },
        updateSignatureImage(value) {
            this.createForm.candidate.signatureImage = value || null;
        },
        requestCreate(isApplicationCompleted) {
            this.submitted = true;
            this.$v.$touch();
            if (this.$v.$invalid) {
                return;
            } else {
                let data = {
                    ...this.createForm,
                    candidate: {
                        ...this.createForm.candidate,
                        candidateJobUuid: this.createForm.candidate.candidateJob?.value,
                        isApplicationCompleted: isApplicationCompleted ? 1 : 0,
                        callDuringWork: this.createForm.candidate.callDuringWork ? 1 : 0,
                        willingOt: this.createForm.candidate.willingOt ? 1 : 0,
                        willingToRelocate: this.createForm.candidate.willingToRelocate ? 1 : 0,
                    },
                    educations: this.createForm.educations
                        .filter(item => item.name)
                        .map(item => ({
                            ...item,
                        })),
                    languages: this.createForm.languages
                        .filter(item => item.name)
                        .map(item => ({
                            ...item,
                        })),
                    experiences: this.createForm.experiences
                        .filter(item => item.company)
                        .map(item => ({
                            ...item,
                            isCurrent: item.isCurrent ? 1 : 0,
                        })),
                    families: this.createForm.families
                        .filter(item => item.name)
                        .map(item => ({
                            ...item,
                            isEmergency: item.isEmergency ? 1 : 0,
                        })),
                    medical: {
                        ...this.createForm.medical,
                        physicalImpairmentDisease: this.createForm.medical.physicalImpairmentDisease ? 1 : 0,
                        seriousIllness: this.createForm.medical.seriousIllness ? 1 : 0,
                        medicationAllergy: this.createForm.medical.medicationAllergy ? 1 : 0,
                        isPregnant: this.createForm.medical.isPregnant ? 1 : 0,
                    },
                };
                this.createCandidate({data})
                    .then((result) => this.$nextTick(() => {
                        if (result?.success) {
                            this.$bvModal.hide('candidate-declaration');
                            if (isApplicationCompleted) {
                                window.location.href = this.$router.resolve({name: 'CandidateApplicationComplete'}).href;
                                return;
                            }
                            this.createForm.candidate.isApplicationCompleted = isApplicationCompleted;
                            this.createForm.uuid = result.data?.uuid || this.createForm.uuid;
                            this.submitted = false;
                            this.$v.$reset();
                            window.location.reload();
                        }
                    }));
            }
        },
        requestUpdate(isApplicationCompleted) {
            this.submitted = true;
            this.$v.$touch();
            if (this.$v.$invalid) {
                return;
            } else {
                let data = {
                    ...this.createForm,
                    candidate: {
                        ...this.createForm.candidate,
                        candidateJobUuid: this.createForm.candidate.candidateJob?.value,
                        isApplicationCompleted: isApplicationCompleted ? 1 : 0,
                        callDuringWork: this.createForm.candidate.callDuringWork ? 1 : 0,
                        willingOt: this.createForm.candidate.willingOt ? 1 : 0,
                        willingToRelocate: this.createForm.candidate.willingToRelocate ? 1 : 0,
                    },
                    educations: this.createForm.educations
                        .filter(item => item.name)
                        .map(item => ({
                            ...item,
                        })),
                    languages: this.createForm.languages
                        .filter(item => item.name)
                        .map(item => ({
                            ...item,
                        })),
                    experiences: this.createForm.experiences
                        .filter(item => item.company)
                        .map(item => ({
                            ...item,
                            isCurrent: item.isCurrent ? 1 : 0,
                        })),
                    families: this.createForm.families
                        .filter(item => item.name)
                        .map(item => ({
                            ...item,
                            isEmergency: item.isEmergency ? 1 : 0,
                        })),
                    medical: {
                        ...this.createForm.medical,
                        physicalImpairmentDisease: this.createForm.medical.physicalImpairmentDisease ? 1 : 0,
                        seriousIllness: this.createForm.medical.seriousIllness ? 1 : 0,
                        medicationAllergy: this.createForm.medical.medicationAllergy ? 1 : 0,
                        isPregnant: this.createForm.medical.isPregnant ? 1 : 0,
                    },
                };
                this.updateCandidate({data})
                    .then((result) => this.$nextTick(() => {
                        if (result?.success) {
                            this.$bvModal.hide('candidate-declaration');
                            if (isApplicationCompleted) {
                                window.location.href = this.$router.resolve({name: 'CandidateApplicationComplete'}).href;
                                return;
                            }
                            this.createForm.candidate.isApplicationCompleted = isApplicationCompleted;
                            this.createForm.uuid = result.data?.uuid || this.createForm.uuid;
                            this.submitted = false;
                            this.$v.$reset();
                            window.location.reload();
                        }
                    }));
            }
        },
        resetForm() {
            this.createForm = this.defaultForm();
            this.submitted = false;
            this.$v.$reset();
        },
    },
    computed: {
        ...mapState(CANDIDATE_MODULE, ['status']),
        candidateUUIDValue() {
            return this.$route.query.candidate || this.candidateUUID || this.createForm.uuid;
        },
        data() {
            return this.$store.state.public.candidate.details;
        },
        candidateJobDdl() {
            return this.$store.state.public.lookup.candidateJobDdl || [];
        },
        candidateJobFromQuery() {
            if (!this.$route.query.job) return null;
            return this.candidateJobDdl.find(item => item.value == this.$route.query.job) || null;
        },
    },
}
</script>
<style scoped>
    .bg-info, .btn-info .text-info {
        background-color:#1AB0E6 !important;
    }
</style>
